import React from "react";

const Articles = () => {
  return (
    <section id="home-articles" className="py-2">
      <div className="container">
        <div className="articles-container">
          <article className="card">
            <img
              src="Images/articles/vinyl.jpg"
              alt=""
              className="article-img"
            />
            {/* <div className="category category-ent">Services</div> */}
            <h3>
              <a href="article.html">Carpet</a>
            </h3>
            <p>
              Vinyl is highly durable and resistant to scratches, stains, and
              water, making it ideal for high-traffic areas and moisture-prone
              spaces like kitchens and bathrooms. It is also easy to clean and
              maintain, requiring only regular sweeping and occasional mopping.
              Vinyl flooring comes in a wide variety of styles, colors, and
              patterns, allowing for endless design possibilities to match any
              décor.
            </p>
          </article>
          <article className="card">
            {/* <div className="category category-sports">Blog</div> */}
            <h3>
              <a href="article.html">Timber</a>
            </h3>
            <p>
              Laminate flooring is a popular choice due to its durability,
              resistance to scratches and stains, and low maintenance
              requirements. With its easy click-lock installation system and a
              wide range of styles, laminate offers an affordable and attractive
              flooring solution for any space. It's also easy to clean, making
              it a practical choice for both homes and businesses.
            </p>
            <img
              src="Images/articles/laminate.jpg"
              alt=""
              className="article-img"
            />
          </article>
          <article className="card">
            <img
              src="Images/articles/garage.jpg"
              alt=""
              className="article-img"
            />
            <div>
              {/* <div className="category category-ent">Services</div> */}
              <h3>
                <a href="article.html">Hybrid Panels</a>
              </h3>
              <p>
                Our garage flooring service offers a range of advantages that
                make it a valuable addition to any garage space. Firstly, garage
                flooring provides enhanced durability, protecting the underlying
                concrete from stains, cracks, and other forms of damage. It is
                resistant to oil, chemicals, and impact, making it ideal for
                garages where vehicles, tools, and heavy equipment are
                frequently used.
              </p>
            </div>
          </article>
          <article className="card">
            <img
              src="Images/articles/vinyl.jpg"
              alt=""
              className="article-img"
            />
            {/* <div className="category category-ent">Services</div> */}
            <h3>
              <a href="article.html">Vinyl</a>
            </h3>
            <p>
              Vinyl is highly durable and resistant to scratches, stains, and
              water, making it ideal for high-traffic areas and moisture-prone
              spaces like kitchens and bathrooms. It is also easy to clean and
              maintain, requiring only regular sweeping and occasional mopping.
              Vinyl flooring comes in a wide variety of styles, colors, and
              patterns, allowing for endless design possibilities to match any
              décor.
            </p>
          </article>
          <article className="card">
            {/* <div className="category category-sports">Blog</div> */}
            <h3>
              <a href="article.html">Tiles</a>
            </h3>
            <p>
              Laminate flooring is a popular choice due to its durability,
              resistance to scratches and stains, and low maintenance
              requirements. With its easy click-lock installation system and a
              wide range of styles, laminate offers an affordable and attractive
              flooring solution for any space. It's also easy to clean, making
              it a practical choice for both homes and businesses.
            </p>
            <img
              src="Images/articles/laminate.jpg"
              alt=""
              className="article-img"
            />
          </article>
          <article className="card">
            <img
              src="Images/articles/garage.jpg"
              alt=""
              className="article-img"
            />
            <div>
              {/* <div className="category category-ent">Services</div> */}
              <h3>
                <a href="article.html">Garage</a>
              </h3>
              <p>
                Our garage flooring service offers a range of advantages that
                make it a valuable addition to any garage space. Firstly, garage
                flooring provides enhanced durability, protecting the underlying
                concrete from stains, cracks, and other forms of damage. It is
                resistant to oil, chemicals, and impact, making it ideal for
                garages where vehicles, tools, and heavy equipment are
                frequently used.
              </p>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Articles;
